var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveBudgetItem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Remove"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 47",
    d: "M30.25 19.125C30.25 26.3737 24.3737 32.25 17.125 32.25C9.87626 32.25 4 26.3737 4 19.125C4 11.8763 9.87626 6 17.125 6C24.3737 6 30.25 11.8763 30.25 19.125Z",
    stroke: "var(--stak-dark-yellow)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M13 23.75L21.75 15",
    stroke: "var(--stak-dark-yellow)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M21.75 23.7505L13 15.0005",
    stroke: "var(--stak-dark-yellow)",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveBudgetItem);
export default __webpack_public_path__ + "static/media/RemoveBudgetItem.b13c6e39647e573dfd7d6fabd9ed47c6.svg";
export { ForwardRef as ReactComponent };